import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import { chatBotSaveLog } from 'actions/item';
import MultipleButtons from 'components/chatBot/messageTypes/multipleButtons';
import WorthyApi from 'lib/api/worthyApi';
import { isMobile } from 'helpers/ApplicationHelper';


class WhatToDoNext extends Component {
    constructor(props) {
        super(props);

        this.state = {
            multipleButtons: Object.assign({}, this.props.message, {buttons: []})
        };

        this.buttonsClick = this.buttonsClick.bind(this);
    }

    componentDidMount() {
        this.prepareButtons();
    }

    prepareButtons(){
        let { buttons } = this.state.multipleButtons;
        let { action } = this.props;
        if(this.props.message){
            _.each(this.props.message.buttons, (button)=> {
                buttons.push(
                    {
                        name: button.label,
                        text: `<div>${button.label}</div>`,
                        response: [
                            {
                                key: `message_update_do_next_details`,
                                direction: "2",
                                type: "message",
                                text: `${button.responseText}`,
                                hide_waves_timeout: "1500",
                                time_to_show: "2000",
                                pauseConversation: true
                            }
                        ],
                        default_response: button.followUpMessage,
                        action: button.action || undefined,
                    }
                );
            });
        }

    }

    logProps(element, name) {
        return {
            key: `${name.toLowerCase().replace(/ /, '_')}_${element}_clicked`,
            version: this.props.cuiVersion,
            item_id: this.props.item.id,
            type: `what_to_do_next_${element}_clicked`,
            direction: '1',
            text: `'${name}' ${element} was clicked`
        };
    }

    buttonsClick(message, button) {
        if(button.action === 'do_next_add_certificate'){
            WorthyApi.handleContactAE(this.props.item.id, 'add_certificate');
        }
        setTimeout(() => {
            document.querySelectorAll('.link-in-message').forEach( (el) =>{
                if(!isMobile()){
                    el.setAttribute('target', '_blank');
                }
                el && el.addEventListener('click', () => {
                    chatBotSaveLog(this.props.item.id, this.logProps('link', el.innerHTML), this.props.cuiVersion);
                });
            });
        }, 5000)
        chatBotSaveLog(this.props.item.id, this.logProps('button', button.name), this.props.cuiVersion);
        this.props.onClick(message, button);
    }

    render(){
        return (
            <div>
                <MultipleButtons id={this.props.id} message={this.state.multipleButtons} onClick={this.buttonsClick} />
            </div>
        );
    }
}

const mapStateToProps = ({Session, Item, ChatBot, Experiments, CuiVersion}) => {
    return {
        Session,
        item: Item,
        cuiVersion: CuiVersion,
    }
};

export default connect(mapStateToProps)(WhatToDoNext);